/* eslint-enable */
import Swiper from "swiper";
/* eslint-disable */

class CardsSlider {
	constructor() {
		this.init();
	}

	init() {
		const that = this;
		Array.from(document.querySelectorAll(".js-swiper-cards-slider")).forEach(
			(el) => this.initSlider(el, that)
		);
	}

	progress(swiper, progress) {
		const currentProgressPercentage = progress.progress * 100;
		Array.from(swiper.querySelectorAll(".swiper-current-progress")).forEach(
			(el) => {
				el.style.width = currentProgressPercentage + "%";
			}
		);
	}

	initSlider(el, that) {
		/* eslint-disable no-unused-vars, no-undef */
		const swiper = new Swiper(el, {
			grabCursor: true,
			slidesPerView: 1.2,
			spaceBetween: 16,

			// pagination dots
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},

			// Responsive
			breakpoints: {
				640: {
					grabCursor: true,
					slidesPerView: 2.1,
					spaceBetween: 16,
				},
				1024: {
					grabCursor: true,
					slidesPerView: 1.1,
					spaceBetween: 24,
				},
			},

			// Progress
			on: {
				progress(progress) {
					const swiper = el;
					that.progress(swiper, progress, el);
				},

				/* eslint-disable */
				init: function () {
					// const swiper = document.querySelector(".swiper-container").swiper;

					const disableSwiper = () => {
						el.swiper.disable();
						el.classList.add("swiper-disabled");
						el.classList.remove("swiper-enabled");
					};

					const enableSwiper = () => {
						el.swiper.enable();
						el.classList.remove("swiper-disabled");
						el.classList.add("swiper-enabled");
					};

					const getWidth = () => {
						var w = window.innerWidth;

						if (w >= 1096 && el.swiper.slides.length < 4) {
							disableSwiper();
						} else {
							enableSwiper();
						}
					};

					window.addEventListener("resize", getWidth);
					getWidth();
				},
				/* eslint-enable */
			},

			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
		/* eslint-enable no-unused-vars, no-undef */
		//console.log(swiper.initialized)
	}
}

export default CardsSlider;
